const crudEmployeesProd = "https://viajando-ando-ykmiteeaiq-uc.a.run.app/api";
// const crudEmployeesProd = "http://localhost:3000/api";

module.exports = {
  crudEmployees: crudEmployeesProd,
};
